import Vue from 'vue'
import App from './App.vue'

import AOS from 'aos'
import 'aos/dist/aos.css';

import LottieVuePlayer from '@lottiefiles/vue-lottie-player';

import VueAwesomeSwiper from 'vue-awesome-swiper'

import "swiper/css/swiper.css";

Vue.use(VueAwesomeSwiper, /* { default global options } */)

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.config.productionTip = false

Vue.use(LottieVuePlayer);

new Vue({
  render: h => h(App),
  mounted() {
    AOS.init({
      duration: 700,
      easing: 'ease-in-out',
      anchorPlacement: 'top-center',
      once: false
    })
  }
}).$mount('#app')
